export enum InfoMessageSeverity {
	success,
	info,
	warning,
	danger
}
